export const win_highlight_popup = {
	WIN_HIGHLIGHT_COUNTER: {
		value: '$600,210',
		config: {
			fontFamily: 'Japanese',
			fontSize: 110,
			letterSpacing: 0,
			align: 'center',
			fill: '#F3D501'
		}
	}
};
